module.exports = __webpack_public_path__ + "img/cover.fdf0d8d.png";